import { render, staticRenderFns } from "./IndicatorComparison.vue?vue&type=template&id=40780c43&scoped=true"
import script from "./IndicatorComparison.vue?vue&type=script&lang=js"
export * from "./IndicatorComparison.vue?vue&type=script&lang=js"
import style0 from "./IndicatorComparison.vue?vue&type=style&index=0&id=40780c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40780c43",
  null
  
)

export default component.exports